import { Component, Injector, OnInit } from '@angular/core';
import { addressI } from 'app/core/interfaces/adress';
import { genderI } from 'app/core/interfaces/currentUser';
import { contactI, patientI } from 'app/core/interfaces/patient';
import { openingHourI } from 'app/core/interfaces/schedule';
import { secretaryI } from 'app/core/interfaces/secretary';
import {  organizatioInitialState, organizationI } from 'app/core/interfaces/organization';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { profileQualificationI } from 'app/core/interfaces/layout';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { OrganizationService } from 'app/core/http/services/organization.service';
import Organization from 'app/core/models/Organization';
import { Location } from 'app/core/interfaces/location';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { skip } from 'rxjs';


@Component({
  selector: 'page-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends BaseComponent implements OnInit {
  
  public address: addressI = <addressI>{};
  public dados : any  = <practitionerI | secretaryI | patientI | organizationI>{};
  public titles = ['Meus dados','Endereço','Horários', 'Dados profissionais'];
  public contact: contactI[] = [];  
  public genders: genderI[] = [];
  public organizationNumber = 0;
  public organizations: Organization[] = [];

  public organization: any =  organizatioInitialState
  public location : Location = <Location>{}

  public validForm = true;
  public selectedTabIndex = 0;
 
  public get openingHours(): openingHourI[] {
    if (this.dados.schedule) {
      return this.dados.schedule;
    }
    return [];

  }


  constructor(private injector: Injector, private route: ActivatedRoute ){
    super(injector)
  }
  
  
  ngOnInit(): void {

    const localStorageTab = localStorage.getItem('tabAfterReload');
    let initialTabName =  localStorageTab ?? 'perfil';
    localStorage.removeItem('tabAfterReload');

    const initialTabIndex = this.getTabIndexByName(initialTabName);

    this.setTabIfAllowed(initialTabIndex);
    this.resolveInitialTabIndex()

    this.listenToTabQueryParam()
    
  }


  checkIfIsFirstAcess(){

     const isFirstAccess = localStorage.getItem('isFirstAccess') === 'true';

     if (isFirstAccess){
      this.showWarningMessage = true
     }

     return isFirstAccess
  }

  locationIsEmpty(location: any){
    return Object.keys(location).length === 0
  }

 

  private resolveInitialTabIndex(): number {
    const tabName = localStorage.getItem('tabAfterReload') ?? 'perfil';
    localStorage.removeItem('tabAfterReload');

    return this.getTabIndexByName(tabName);
  }

  private listenToTabQueryParam(): void {
    this.route.queryParams
      .pipe(skip(1))
      .subscribe((params) => {
        const tabName = params['tab'];

        if (tabName){
          const index = this.getTabIndexByName(tabName);

          if (this.selectedTabIndex !== index) {
            this.setTabIfAllowed(index);
          }
        }
        
      });
  }

  private setTabIfAllowed(index: number): void {
    console.log("table allow", this.isTabAllowed(index))
    if (this.isTabAllowed(index)) {
      this.selectedTabIndex = index;
    }
  }

  private isTabAllowed(index: number): boolean {
    return !(this.checkIfIsFirstAcess() && index > 0);
  }

  onTabChange(event: MatTabChangeEvent): void {
    const tabName = this.getTabNameByIndex(event.index);

    this.router.navigate([], {
      queryParams: { tab: tabName },
      queryParamsHandling: 'merge'
    });
  }

  getTabIndexByName(tabName: string): number {
    switch (tabName) {
      case 'perfil':
        return 0;
      case 'localizacao':
        return 1;
      case 'horario':
        return 2;
      default:
        return 0;
    }
  }

  getTabNameByIndex(index: number): string {
    switch (index) {
      case 0:
        return 'perfil';
      case 1:
        return 'localizacao';
      case 2:
        return 'horario';
      default:
        return 'perfil';
    }
  }

  setLocation(location: any){
    this.location = location

    if (this.locationIsEmpty(location)){
      this.showWarningMessage = true;
    }else{
       this.showWarningMessage = false
    }

   
  }

  onUpdateHours(hours: openingHourI[]) {
    this.dados.openingHours = hours;
  }

  initHours() {
  
    if (!this.dados.openingHours || this.dados.openingHours.length == 0) {
      this.dados.openingHours = [];
      for (let i = 0; i < 7; i++) {
        this.dados.openingHours.push({
          dayOfWeek: i,
          timeStart: '',
          timeEnd: '12:00'
        });

        this.dados.openingHours.push({
          dayOfWeek: i,
          timeStart: '14:00',
          timeEnd: '18:00'
        });
      }
    }  
  }

  onUpdateQualifications(dados: profileQualificationI) {
    this.dados.qualifications = dados.qualifications;
    this.dados.courses = dados.courses;
    this.dados.languages = dados.languages;
  }

 
}